<template>
  <div class="coding-line-editor">
    <div
      ref="gutter"
      class="coding-line-gutter"
      aria-hidden="true"
    >
      <div
        v-for="n in lineCount"
        :key="n"
        class="coding-line-num"
      >{{ n }}</div>
    </div>
    <textarea
      ref="textarea"
      class="coding-line-textarea"
      :value="modelValue"
      spellcheck="false"
      @input="onInput"
      @keydown="$emit('keydown', $event)"
      @scroll="syncGutterScroll"
    ></textarea>
  </div>
</template>

<script>
export default {
  name: 'CodingLineTextarea',
  props: {
    modelValue: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue', 'input', 'keydown'],
  computed: {
    lineCount() {
      const text = String(this.modelValue ?? '')
      const lines = text.split('\n').length
      return Math.max(lines, 1)
    }
  },
  methods: {
    onInput(e) {
      const v = e && e.target ? e.target.value : ''
      this.$emit('update:modelValue', v)
      this.$emit('input', e)
    },
    syncGutterScroll(e) {
      const gutter = this.$refs.gutter
      const ta = e && e.target ? e.target : this.$refs.textarea
      if (gutter && ta) gutter.scrollTop = ta.scrollTop
    }
  }
}
</script>

<style scoped>
.coding-line-editor {
  display: flex;
  flex: 1 1 auto;
  min-height: 260px;
  min-width: 0;
  border: 1px solid #ced4da;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.coding-line-gutter {
  flex: 0 0 auto;
  overflow: hidden;
  background: #f1f5f9;
  border-right: 1px solid #e2e8f0;
  user-select: none;
  padding: 10px 0;
  min-width: 2.75rem;
}

.coding-line-num {
  padding: 0 10px 0 6px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
  font-size: 0.8125rem;
  line-height: 1.45;
  color: #94a3b8;
  text-align: right;
  white-space: nowrap;
}

.coding-line-textarea {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  width: 100%;
  height: 100%;
  resize: none;
  border: none;
  outline: none;
  box-shadow: none;
  tab-size: 4;
  padding: 10px 12px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
  font-size: 0.8125rem;
  line-height: 1.45;
  background: transparent;
}

.coding-line-textarea:focus {
  outline: none;
  box-shadow: none;
}
</style>
